import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { deleteAirline } from "../../api/apiAirlines";
import parseError from "../../utils/parseError";

const useDeleteAirline = () => {
    const queryClient = useQueryClient();

    const { mutate: deleteAirlineAction, isPending } = useMutation({
        mutationFn: deleteAirline,
        onSuccess: (res) => {
            const message = res?.message || "Airline deleted successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["airlines"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to delete airline");
        },
    });

    return { deleteAirline: deleteAirlineAction, isPending };
};

export default useDeleteAirline;
